export default {
  state: {
    selection: {},
    defaultSelection: "4232",
    options: [],
  },

  mutations: {
    setSelection(state, selection) {
      state.selection = selection;
    },

    setDefaultSelection(state, defaultSelection) {
      state.defaultSelection = defaultSelection;
    },

    setOptions(state, options) {
      state.options = options;
    },
  },
};
